import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function SocialProof() {
  return <section className="py-6 md:py-28 bg-cream-200" data-id="element-197">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-198">
        <FadeIn data-id="element-199">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-cream-300 relative overflow-hidden" data-id="element-200">
            <Quote className="absolute top-8 left-8 w-16 h-16 text-sage-100 -z-0" data-id="element-201" />

            <div className="relative z-10 text-center" data-id="element-202">
              <span className="text-sage-600 font-bold tracking-wider uppercase text-sm mb-6 block" data-id="element-203">
                Prueba de Realidad
              </span>

              <p className="text-xl md:text-2xl lg:text-3xl text-charcoal font-serif italic leading-relaxed mb-8" data-id="element-204">
                "En solo 7 días, la mayoría de nuestras usuarias reportan que
                recuperan el 'calce' de su ropa habitual. No es magia, es
                medicina funcional aplicada a tu vida diaria."
              </p>

              <p className="text-lg text-charcoal-light font-sans max-w-2xl mx-auto" data-id="element-205">
                Verás cómo tus ojos se ven más brillantes y tu nivel de energía
                se mantiene estable desde la mañana hasta la noche.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}